import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlesSection() {
  return (
    <section className="w-full bg-background-100" id="articles">
      <div className="px-6 md:px-10 py-14 md:py-20">
        <div className="max-w-6xl mx-auto">
          <div className="mb-10">
            <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-200 text-foreground-600 text-xs font-medium tracking-wide uppercase mb-5">
              Articles SEO
            </span>
            <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
                Guide et <span className="text-accent-600">Ressources</span>
              </h2>
              <p className="text-foreground-500 text-sm max-w-md">
                Des articles approfondis, comparatifs détaillés et tutoriels pour maîtriser le hipobuy spreadsheet.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {articles.map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group bg-background-50 border border-background-200 rounded-2xl overflow-hidden cursor-pointer hover:border-accent-300 hover:shadow-md transition-all"
              >
                <div className="w-full h-48 overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                      {article.category}
                    </span>
                    <span className="text-xs text-foreground-400">{article.readTime} de lecture</span>
                  </div>
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-accent-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                </div>
              </Link>
            ))}
          </div>

          <div className="text-center mt-10">
            <Link
              to="/article/guide-achat-hipobuy-spreadsheet"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-accent-500 text-accent-600 font-semibold text-sm whitespace-nowrap hover:bg-accent-500 hover:text-background-50 transition-all cursor-pointer"
            >
              Voir le Guide d'Achat
              <i className="ri-shopping-bag-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}